/* eslint-disable @typescript-eslint/camelcase */

import Axios from "axios";
import { StudioAttributes } from "@/interfaces/studioAttributes";
import { WidgetConfiguration } from "@/interfaces/widgetConfiguration";
import { WidgetState } from "@/interfaces/widgetState";
import { WidgetPayload } from "@/interfaces/widgetPayload";
import { Layout } from "@/interfaces/layout";
import { Script } from "@/interfaces/script";
import { Page } from "@/interfaces/page";

export class ScriptService {
    public static async getScriptById(
        id: string,
        token: string
    ): Promise<Script> {
        const uri = `/api/script/by_id/${id}`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    }

    public static async getOwnScripts(token: string): Promise<Script> {
        const uri = `/api/script/all/`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    }

    public static async addScript(
        name: string,
        owner: string,
        token: string
    ): Promise<Script> {
        const uri = "/api/script";
        const response = await Axios.post(
            uri,
            { name, owner },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    public static async updateScript(script: Script, token: string) {
        const uri = "/api/script";
        const response = await Axios.put(uri, script, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(r => {
                return r;
            })
            .catch(error => {
                return error.response;
            });
        return response;
    }

    public static async deleteScript(id: string, token: string) {
        const uri = "/api/script";
        const response = await Axios.delete(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data: {
                id,
            },
        });
        return response.status === 200;
    }

    public static async addPage(
        script_id: string,
        id: number,
        widgetConfig: WidgetConfiguration<WidgetState, WidgetPayload>[],
        layout: Layout[],
        attributes: StudioAttributes,
        token: string
    ): Promise<Page> {
        const uri = "/api/script/page";
        const response = await Axios.post(
            uri,
            {
                script_id,
                id,
                widgetConfig,
                layout,
                attributes,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    public static async updatePage(
        script_id: string,
        id: number,
        widgetConfig: WidgetConfiguration<WidgetState, WidgetPayload>[],
        layout: Layout[],
        attributes: StudioAttributes,
        token: string
    ) {
        const uri = "/api/script/page";
        const response = await Axios.put(
            uri,
            {
                script_id,
                id,
                widgetConfig,
                layout,
                attributes,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.status === 200;
    }

    public static async updatePageTitle(
        script_id: string,
        id: number,
        title: string,
        token: string
    ): Promise<{
        data: Page;
        status: number;
    }> {
        const uri = `api/script/page/title`;

        const response = await Axios.put(
            uri,
            {
                script_id,
                id,
                title,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then(response => {
                return {
                    data: response.data,
                    status: response.status,
                };
            })
            .catch(error => {
                return {
                    data: error.response.data,
                    status: error.response.status,
                };
            });

        return response;
    }
    public static async deletePage(
        script_id: string,
        id: number,
        token: string
    ) {
        const uri = "/api/script/page";
        const response = await Axios.delete(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data: {
                script_id,
                id,
            },
        });
        return response.status === 200;
    }
}
